(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hebeso-cart"]) return;
  try {
    
  (() => {
    if (customElements.get('hebeso-cart')) return;
    class HebesoCart extends HTMLElement {
      connectedCallback() {
        if (this.initialised) return;
        this.initialised = true;
        this.busy = false;
        this.stale = false;
        this.dialog = this.querySelector('dialog');
        this.classList.add('hbc-ready');
        this.addEventListener('click', event => this.onClick(event));
        this.addEventListener('change', event => this.onChange(event));
        this.addEventListener('submit', event => this.onSubmit(event));
        if (this.dialog) {
          this.dialog.addEventListener('close', () => {
            document.documentElement.style.overflow = this.previousOverflow || '';
            if (this.opener?.isConnected) this.opener.focus();
          });
          this.dialog.addEventListener('click', event => {
            if (event.target !== this.dialog) return;
            const rect = this.dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
          });
        }
        this.updateCount();
      }
      async open(opener) {
        if (!this.dialog) return;
        if (!this.dialog.open) {
          this.opener = opener || document.activeElement;
          this.previousOverflow = document.documentElement.style.overflow;
          this.dialog.showModal();
          document.documentElement.style.overflow = 'hidden';
        }
        await this.sync();
      }
      status(message) { this.querySelector('[data-hbc-status]').textContent = message || ''; }
      error(message) {
        const element = this.querySelector('[data-hbc-error]');
        element.hidden = !message;
        element.querySelector('p').textContent = message || '';
      }
      setBusy(value) {
        this.busy = value;
        this.setAttribute('aria-busy', String(value));
        this.querySelectorAll('[data-hbc-content] button:not([data-hbc-close]), [data-hbc-content] input, [data-hbc-content] select, [data-hbc-content] textarea').forEach(control => {
          if (value) {
            control.dataset.hbcWasDisabled = String(control.disabled);
            control.disabled = true;
          } else if ('hbcWasDisabled' in control.dataset) {
            control.disabled = control.dataset.hbcWasDisabled === 'true';
            delete control.dataset.hbcWasDisabled;
          }
        });
        if (!value && this.stale) this.querySelectorAll('[data-hbc-checkout]').forEach(button => { button.disabled = true; });
      }
      async refresh(focusKey) {
        const url = new URL(window.location.href);
        url.searchParams.delete('section_id');
        url.searchParams.set('sections', this.dataset.sectionId);
        url.hash = '';
        const response = await fetch(url.toString(), {credentials:'same-origin', cache:'no-store'});
        if (!response.ok) throw new Error(this.dataset.error);
        const sections = await response.json();
        const html = sections[this.dataset.sectionId];
        if (typeof html !== 'string') throw new Error(this.dataset.error);
        const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-hbc-content]');
        if (!next) throw new Error(this.dataset.error);
        const content = this.querySelector('[data-hbc-content]');
        const scrollTop = this.dialog?.scrollTop;
        content.replaceWith(document.importNode(next, true));
        this.stale = false;
        this.updateCount();
        const pricingState = this.querySelector('[data-hbc-cart-state]');
        if (pricingState && window.HebesoCartPricing) window.HebesoCartPricing.setCart(JSON.parse(pricingState.textContent));
        if (this.dialog) this.dialog.scrollTop = scrollTop;
        if (focusKey) {
          const target = [...this.querySelectorAll('[data-hbc-focus]')].find(node => node.dataset.hbcFocus === focusKey && !node.disabled) || this.querySelector('[data-hbc-focus="empty"], [data-hbc-close], [data-hbc-quantity]');
          target?.focus({preventScroll:true});
        }
      }
      async sync() {
        if (this.busy) { this.pendingSync = true; return; }
        this.setBusy(true);
        this.status(this.dataset.loading);
        const focusKey = this.contains(document.activeElement) ? document.activeElement.dataset.hbcFocus || 'close' : null;
        try { await this.refresh(focusKey); this.error(''); this.status(''); }
        catch { this.stale = true; this.error(this.dataset.error); this.status(''); }
        finally { this.setBusy(false); this.runPending(); }
      }
      async reconcile() {
        if (!this.isConnected || this.busy || (this.dialog && !this.dialog.open)) return;
        try {
          const response = await fetch(this.dataset.root + 'cart.js', {credentials:'same-origin',cache:'no-store'});
          if (!response.ok) return;
          const current = await response.json();
          const content = this.querySelector('[data-hbc-content]');
          const lines = [...this.querySelectorAll('[data-hbc-line]')].map(line => line.dataset.key + ':' + line.dataset.quantity).sort();
          const latest = current.items.map(item => item.key + ':' + item.quantity).sort();
          if (String(current.total_price) !== content.dataset.total || JSON.stringify(lines) !== JSON.stringify(latest)) await this.sync();
        } catch {}
      }
      runPending() {
        if (!this.pendingSync) return;
        this.pendingSync = false;
        clearTimeout(this.pendingTimer);
        this.pendingTimer = setTimeout(() => { if (this.isConnected) this.sync(); }, 120);
      }
      updateCount() {
        const count = Number(this.querySelector('[data-hbc-content]')?.dataset.count || 0);
        document.querySelectorAll('[data-header-cart-count]').forEach(node => {
          node.dataset.headerCartCount = count ? String(count) : '';
          node.classList.toggle('visible', count > 0);
          node.closest('.site-header-cart-button')?.classList.toggle('count-hidden', count === 0);
        });
      }
      propertiesKey(properties) {
        const entries = Array.isArray(properties) ? properties : Object.entries(properties || {});
        if (entries.some(entry => !Array.isArray(entry) || entry.length !== 2)) throw new Error(this.dataset.error);
        return JSON.stringify(entries.map(([key,value]) => [String(key),value]).sort(([a],[b]) => a.localeCompare(b)));
      }
      identifyLine(line) {
        if (!line) throw new Error(this.dataset.error);
        return {key:line.dataset.key,variant:line.dataset.variant,sellingPlan:line.dataset.sellingPlan || '',properties:this.propertiesKey(JSON.parse(line.dataset.properties || '{}'))};
      }
      findItem(items, identity) {
        const exact = items.find(item => item.key === identity.key);
        if (exact) return exact;
        const matches = items.filter(item => String(item.variant_id) === identity.variant && String(item.selling_plan_allocation?.selling_plan?.id || '') === identity.sellingPlan && this.propertiesKey(item.properties) === identity.properties);
        if (matches.length > 1) throw new Error(this.dataset.error);
        return matches[0];
      }
      async mutate(endpoint, body, focusKey, message) {
        if (this.busy || this.stale) return;
        this.setBusy(true);
        this.error('');
        this.status(this.dataset.loading);
        let errorMessage = '';
        try {
          const identity = endpoint === 'change' ? this.identifyLine([...this.querySelectorAll('[data-hbc-line]')].find(node => node.dataset.key === body.id)) : null;
          let response;
          let data;
          for (let attempt = 0; attempt < 2; attempt++) {
            let payload = body;
            if (identity) {
              const currentResponse = await fetch(this.dataset.root + 'cart.js', {credentials:'same-origin',cache:'no-store'});
              if (!currentResponse.ok) throw new Error(this.dataset.error);
              const current = await currentResponse.json();
              const target = this.findItem(current.items, identity);
              if (!target && body.quantity === 0) { response = {ok:true}; data = {}; break; }
              if (!target) throw new Error(this.dataset.error);
              payload = {id:target.key,quantity:body.quantity};
            }
            response = await fetch(this.dataset.root + 'cart/' + endpoint + '.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload),hebesoCartInternal:true});
            data = await response.json();
            if (!identity || response.status !== 400 || attempt !== 0) break;
          }
          if (!response.ok || data.status >= 400) errorMessage = typeof data.description === 'string' ? data.description : this.dataset.error;
          else if (typeof window.api?.theme?.triggerEvent === 'function') {
            try { window.api.theme.triggerEvent('cart:updated', {cancel() {}}); } catch {}
          }
        } catch { errorMessage = this.dataset.error; }
        try { await this.refresh(focusKey); }
        catch { this.stale = true; errorMessage = this.dataset.error; }
        this.error(errorMessage);
        this.status(errorMessage ? '' : message || this.dataset.updated);
        this.setBusy(false);
        this.runPending();
      }
      changeQuantity(line, quantity, focusKey) {
        const input = line.querySelector('[data-hbc-quantity]');
        const minimum = Number(input?.min || 1);
        const step = Number(input?.step || 1);
        const maximum = input?.max ? Number(input.max) : Infinity;
        const next = Math.min(maximum, Math.max(minimum, minimum + Math.round((quantity - minimum) / step) * step));
        if (!Number.isFinite(next) || !Number.isInteger(next)) return;
        if (next === Number(line.dataset.quantity)) { if (input) input.value = String(next); return; }
        this.mutate('change', {id:line.dataset.key,quantity:next}, focusKey);
      }
      onClick(event) {
        const close = event.target.closest('[data-hbc-close]');
        if (close) { this.dialog?.close(); return; }
        if (event.target.closest('[data-hbc-reload]')) { this.sync(); return; }
        const remove = event.target.closest('[data-hbc-remove]');
        const step = event.target.closest('[data-hbc-step]');
        if (remove) {
          event.preventDefault();
          event.stopPropagation();
          this.mutate('change', {id:remove.closest('[data-hbc-line]').dataset.key,quantity:0}, 'heading');
        }
        if (step) {
          event.preventDefault();
          event.stopPropagation();
          const line = step.closest('[data-hbc-line]');
          const input = line.querySelector('[data-hbc-quantity]');
          this.changeQuantity(line, Number(line.dataset.quantity) + Number(step.dataset.hbcStep) * Number(input.step || 1), step.dataset.hbcFocus);
        }
      }
      onChange(event) {
        const input = event.target;
        if (input.matches('[data-hbc-quantity]')) this.changeQuantity(input.closest('[data-hbc-line]'), Number(input.value), input.dataset.hbcFocus);
        if (input.matches('[data-hbc-note]')) this.mutate('update',{note:input.value},'note');
        if (input.matches('[data-hbc-variant]')) {
          const option = input.selectedOptions[0];
          const form = input.closest('form');
          form.querySelector('[data-hbc-offer-price]').textContent = option.dataset.price;
          form.querySelector('[data-hbc-offer-unit]').textContent = option.dataset.unitPrice || '';
        }
      }
      onSubmit(event) {
        const form = event.target;
        if (form.matches('[data-hbc-offer]')) {
          event.preventDefault();
          const variant = form.elements.namedItem('id').value;
          this.mutate('add',{items:[{id:Number(variant),quantity:1}]},'heading',this.dataset.added);
        }
        if (form.matches('[data-hbc-items-form]')) {
          if (this.busy || this.stale) { event.preventDefault(); return; }
          if (event.submitter?.name === 'checkout' && typeof window.api?.theme?.triggerEvent === 'function') {
            window.api.theme.triggerEvent('cart:checkout', {cancel() { event.preventDefault(); }});
          }
          if (event.submitter?.name !== 'checkout') {
            event.preventDefault();
            const input = document.activeElement;
            if (input?.matches('[data-hbc-quantity]')) this.changeQuantity(input.closest('[data-hbc-line]'),Number(input.value),input.dataset.hbcFocus);
          }
        }
      }
    }
    customElements.define('hebeso-cart', HebesoCart);
    const cart = () => document.querySelector('hebeso-cart');
    let timer;
    let openAfterAdd = false;
    let reconcileTimers = [];
    const notify = isAdd => {
      openAfterAdd = openAfterAdd || isAdd;
      if (isAdd) {
        reconcileTimers.forEach(clearTimeout);
        reconcileTimers = [1000,3000].map(delay => setTimeout(() => cart()?.reconcile(), delay));
      }
      clearTimeout(timer);
      timer = setTimeout(() => {
        const element = cart();
        if (!element) return;
        const open = openAfterAdd;
        openAfterAdd = false;
        if (open && element.dialog) element.open();
        else element.sync();
      }, 180);
    };
    const operation = value => {
      try {
        const url = new URL(value, location.href);
        if (url.origin !== location.origin) return null;
        return url.pathname.match(/\/cart\/(add|change|update|clear)(?:\.js|\.json)?\/?$/)?.[1] || null;
      } catch { return null; }
    };
    const originalFetch = window.fetch;
    window.fetch = async function(input, init) {
      const response = await originalFetch.apply(this, arguments);
      const action = operation(typeof input === 'string' || input instanceof URL ? String(input) : input?.url);
      const method = init?.method || input?.method || 'GET';
      if (action && method.toUpperCase() === 'POST' && response.ok && !init?.hebesoCartInternal) notify(action === 'add');
      return response;
    };
    const originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url) {
      const action = operation(url);
      if (action && String(method).toUpperCase() === 'POST') {
        this.addEventListener('load', () => { if (this.status >= 200 && this.status < 300) notify(action === 'add'); },{once:true});
      }
      return originalOpen.apply(this,arguments);
    };
    document.addEventListener('click', event => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const anchor = event.target.closest('a[href]');
      const element = cart();
      if (!anchor || !element?.dialog || anchor.hasAttribute('data-hbc-full-cart') || anchor.target === '_blank') return;
      const url = new URL(anchor.href, location.href);
      if (url.origin === location.origin && url.pathname.replace(/\/$/,'') === element.dataset.cartUrl.replace(/\/$/,'')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        element.open(anchor);
      }
    },true);
    window.addEventListener('pageshow', event => { if (event.persisted) cart()?.sync(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hebeso-set-page"]) return;
  try {
    
(() => {
  'use strict';
  function initializePage() {
  const root = document.querySelector('[data-hebeso-set-page]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const stickyHeader = document.querySelector('.site-header-wrapper.site-header--sticky');
  if (stickyHeader) {
    const updateHeaderHeight = () => root.style.setProperty('--hsp-header-height', `${stickyHeader.getBoundingClientRect().height}px`);
    updateHeaderHeight();
    new ResizeObserver(updateHeaderHeight).observe(stickyHeader);
  }
  const mobileBar = root.querySelector('.hsp-mobile-bar');
  if (mobileBar) {
    const updateMobileBarHeight = () => document.documentElement.style.setProperty('--hsp-mobile-bar-height', `${Math.ceil(mobileBar.getBoundingClientRect().height)}px`);
    updateMobileBarHeight();
    new ResizeObserver(updateMobileBarHeight).observe(mobileBar);
  }
  const config = JSON.parse(root.querySelector('[data-hsp-config]').textContent);
  const pricing = window.HebesoCartPricing;
  const stock = window.HebesoStockGuard?.create(config.stockStrings);
  const $ = selector => root.querySelector(selector);
  const $$ = selector => [...root.querySelectorAll(selector)];
  const words = config.strings;
  const previewWords = config.quickViewStrings;
  const previewText = (key, values = {}) => previewWords[key].replace(/\{(\w+)\}/g, (match, name) => String(values[name] ?? match));
  const text = (key, values = {}) => words[key].replace(/\{(\w+)\}/g, (match, name) => String(values[name] ?? match));
  const html = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const money = cents => new Intl.NumberFormat(config.locale || 'de-DE', {style:'currency', currency:config.currency || 'EUR'}).format(cents / 100);
  const cartRoot = config.root.replace(/\/?$/, '/');
  const params = new URL(location.href).searchParams;
  const items = new Map(config.catalog.map(item => [String(item.variantId), item]));
  const selection = new Map();
  let firstId = '', edit = null, ready = false, busy = false, completed = false, completedKey = '', serverCart = {items:[]};
  const entries = () => [...selection].filter(([,quantity]) => quantity > 0).map(([id, quantity]) => ({...items.get(id), quantity}));
  const group = (state, key) => state.items.filter(item => item.properties?._hebeso_set_id === key);
  const signature = lines => JSON.stringify(lines.map(line => [line.variant_id,line.quantity,line.selling_plan_allocation?.selling_plan?.id || '',line.properties]).sort((a,b) => a[0]-b[0]));
  function error(message) { $('[data-hsp-error]').textContent = message; $('[data-hsp-error]').hidden = !message; }
  function announce(message) { $('[data-hsp-status]').textContent = message; }
  function orderedItems() { return [...items.values()].sort((a,b) => Number(String(b.variantId) === firstId) - Number(String(a.variantId) === firstId)); }
  function canSubmit(q) { return ready && !busy && !completed && q.count > 0 && (Boolean(edit) || q.eligibleCount >= 2); }
  function controls(item, quantity) {
    const id = String(item.variantId), label = item.name;
    return `<div class="hsp-quantity"><button type="button" data-hsp-action="minus" data-id="${id}" aria-label="${html(text('decrease',{name:label}))}" ${quantity ? '' : 'disabled'}>−</button><output aria-label="${html(words.quantity)}">${quantity}</output><button type="button" data-hsp-action="plus" data-id="${id}" aria-label="${html(text('increase',{name:label}))}" ${item.available && quantity < 99 ? '' : 'disabled'}>+</button></div>`;
  }
  function buildCatalog() {
    $('[data-hsp-grid]').innerHTML = orderedItems().map(item => {
      const id = String(item.variantId);
      return `<article class="hsp-card" data-card-id="${id}"><button type="button" class="hsp-photo" data-hsp-preview="${id}" aria-haspopup="dialog" aria-label="${html(previewText('open',{name:item.name}))}"><img src="${html(item.image)}" alt="" width="500" height="500" loading="lazy"><span class="hsp-chosen" data-chosen hidden>${html(words.selected)}</span></button><div class="hsp-card-body"><h3>${html(item.name)}</h3><p class="hsp-variant">${html(item.variantTitle === 'Default Title' ? '' : item.variantTitle)}</p><p class="hsp-price">${money(item.price)}</p><button class="hsp-details" type="button" data-hsp-preview="${id}" aria-haspopup="dialog" aria-label="${html(previewText('open',{name:item.name}))}">${html(previewWords.details)}</button><div data-card-controls></div></div></article>`;
    }).join('');
    filterCatalog();
  }
  function render() {
    if (!pricing) return;
    const selected = entries(), q = pricing.quote(selected, serverCart, completedKey || edit?.key);
    if (params.has('product') && firstId) $('[data-hsp-seed]').hidden = !(selection.get(firstId) > 0);
    $$('[data-card-id]').forEach(card => {
      const id = card.dataset.cardId, item = items.get(id), quantity = selection.get(id) || 0;
      card.classList.toggle('is-selected', quantity > 0);
      card.querySelector('[data-chosen]').hidden = !quantity;
      const box = card.querySelector('[data-card-controls]');
      const desired = quantity ? 'quantity' : 'add';
      if (box.dataset.mode !== desired) {
        box.dataset.mode = desired;
        box.innerHTML = quantity ? controls(item,quantity) : `<button class="hsp-add" type="button" data-hsp-action="plus" data-id="${id}" ${item.available ? '' : 'disabled'}>${html(item.available ? words.add : words.sold_out)}</button>`;
      }
      if (quantity) {
        box.querySelector('output').textContent = quantity;
        box.querySelector('[data-hsp-action="plus"]').disabled = !item.available || quantity >= 99;
      }
    });
    $('[data-hsp-selected]').innerHTML = orderedItems().filter(item => (selection.get(String(item.variantId)) || 0) > 0).map(item => {
      const id = String(item.variantId), quantity = selection.get(id);
      return `<li class="hsp-selected-item"><img src="${html(item.image)}" alt="" width="64" height="64"><div><button class="hsp-selected-name" type="button" data-hsp-preview="${id}" aria-haspopup="dialog" aria-label="${html(previewText('open',{name:item.name}))}"><strong>${html(item.name)}</strong></button>${item.variantTitle === 'Default Title' ? '' : `<small>${html(item.variantTitle)}</small>`}${controls(item,quantity)}</div><button class="hsp-remove" type="button" data-hsp-action="remove" data-id="${id}" aria-label="${html(text('remove',{name:item.name}))}">×</button></li>`;
    }).join('');
    $('[data-hsp-empty]').hidden = q.count > 0;
    $$('[data-hsp-count]').forEach(node => { node.textContent = text('count',{count:q.count}); });
    $$('[data-hsp-total]').forEach(node => { node.textContent = money(q.total); });
    $('[data-hsp-original]').textContent = money(q.original);
    $('[data-hsp-saving]').textContent = money(q.saving);
    $('[data-hsp-progress]').textContent = q.rate ? text('saving',{rate:q.rate,amount:money(q.saving)}) : words.minimum;
    $('[data-hsp-context]').textContent = q.existingCount ? text('cart_context',{count:q.existingCount}) : words.discount_note;
    const shipping = $('[data-hsp-shipping]');
    let shippingSaving = 0;
    if (shipping) {
      const threshold = Number(shipping.dataset.threshold);
      const subtotal = Math.max(0, completed ? serverCart.total_price : q.cartSubtotal);
      const remaining = Math.max(0, threshold - subtotal);
      if (ready && q.count > 0 && remaining === 0) shippingSaving = Math.max(0, Number(shipping.dataset.shippingFee) || 0);
      const message = remaining ? shipping.dataset.remaining.replace('__amount__', money(remaining)) : shipping.dataset.reached;
      shipping.hidden = !ready;
      shipping.classList.toggle('is-complete', remaining === 0);
      shipping.querySelector('[data-hsp-shipping-message]').textContent = message;
      const progress = shipping.querySelector('[data-hsp-shipping-progress]');
      progress.value = Math.min(100, subtotal / threshold * 100);
      progress.setAttribute('aria-valuetext', message);
    }
    $('[data-hsp-shipping-saving-row]').hidden = shippingSaving === 0;
    $('[data-hsp-total-saving-row]').hidden = shippingSaving === 0;
    $('[data-hsp-shipping-saving]').textContent = money(shippingSaving);
    $('[data-hsp-total-saving]').textContent = money(q.saving + shippingSaving);
    $$('[data-hsp-tier]').forEach(node => { node.classList.toggle('achieved', q.eligibleCount >= Number(node.dataset.hspTier)); });
    $$('[data-hsp-submit]').forEach(button => { button.disabled = !canSubmit(q); button.textContent = busy ? words.saving_now : completed ? words.added : edit ? words.save : words.submit; });
    $('[data-hsp-title]').textContent = edit ? words.edit_title : words.title;
    $('[data-hsp-edit-note]').hidden = !edit;
    $('[data-hsp-cancel]').hidden = !edit;
    $('[data-hsp-browser]').inert = busy || completed;
    $('[data-hsp-selected]').inert = busy || completed;
    root.setAttribute('aria-busy', String(busy));
    renderPreviewControls();
  }
  const dialog = $('[data-hsp-dialog]');
  const previewCache = new Map();
  let previewId = '', previewOpener = null, previewVersion = 0, previewImages = [], backdropStart = false;
  function imageUrl(value, width) {
    if (!value) return '';
    try {
      const url = new URL(value, location.origin);
      if (!['https:', 'http:'].includes(url.protocol)) return '';
      if (width && (url.hostname === 'cdn.shopify.com' || url.origin === location.origin)) url.searchParams.set('width', String(width));
      return url.href;
    } catch { return ''; }
  }
  function descriptionContent(value) {
    const source = new DOMParser().parseFromString(String(value || ''), 'text/html');
    const fragment = document.createDocumentFragment();
    const allowed = new Set(['P','DIV','SPAN','BR','STRONG','B','EM','I','U','UL','OL','LI','H1','H2','H3','H4','H5','H6','BLOCKQUOTE','TABLE','THEAD','TBODY','TR','TH','TD','IMG','SUP','SUB','HR']);
    const omitted = new Set(['SCRIPT','STYLE','IFRAME','OBJECT','EMBED','FORM','BUTTON','INPUT','SELECT','TEXTAREA','SVG','LINK','META','NOSCRIPT','TEMPLATE']);
    function append(node, parent) {
      if (node.nodeType === 3) { parent.append(document.createTextNode(node.textContent)); return; }
      if (node.nodeType !== 1 || omitted.has(node.tagName)) return;
      if (!allowed.has(node.tagName)) { [...node.childNodes].forEach(child => append(child, parent)); return; }
      const element = document.createElement(['H1','H2'].includes(node.tagName) ? 'h3' : node.tagName.toLowerCase());
      if (node.tagName === 'IMG') {
        const src = imageUrl(node.getAttribute('src'), 800);
        if (!src) return;
        element.src = src; element.alt = node.getAttribute('alt') || ''; element.loading = 'lazy';
      }
      if (['TD','TH'].includes(node.tagName)) {
        ['colspan','rowspan'].forEach(name => { const count = node.getAttribute(name); if (/^\d{1,2}$/.test(count || '')) element.setAttribute(name, count); });
      }
      [...node.childNodes].forEach(child => append(child, element));
      parent.append(element);
    }
    [...source.body.childNodes].forEach(node => append(node, fragment));
    if (!fragment.textContent.trim() && !fragment.querySelector('img')) fragment.append(document.createTextNode(previewWords.no_description));
    return fragment;
  }
  function renderPreviewControls() {
    if (!previewId || !dialog.open) return;
    const item = items.get(previewId), quantity = selection.get(previewId) || 0;
    const box = $('[data-hsp-preview-controls]');
    $('[data-hsp-preview-count]').textContent = quantity ? previewText('in_set',{count:quantity}) : previewWords.not_selected;
    const mode = quantity ? 'quantity' : 'add';
    if (box.dataset.mode !== mode || box.dataset.id !== previewId) {
      box.dataset.mode = mode; box.dataset.id = previewId;
      box.innerHTML = quantity ? controls(item, quantity) : `<button class="hsp-add" type="button" data-hsp-action="plus" data-id="${previewId}">${html(item.available ? words.add : words.sold_out)}</button>`;
    }
    if (quantity) box.querySelector('output').textContent = quantity;
    box.querySelectorAll('[data-hsp-action]').forEach(button => {
      button.disabled = busy || !ready || completed || (button.dataset.hspAction === 'plus' ? !item.available || quantity >= 99 : !quantity);
    });
  }
  function selectPreviewImage(index) {
    const source = previewImages[index];
    const image = $('[data-hsp-preview-image]');
    if (!source) { image.hidden = true; return; }
    image.hidden = false; image.src = imageUrl(source, 900);
    image.alt = previewText('image',{name:items.get(previewId).name,index:index + 1,count:previewImages.length});
    $$('[data-hsp-image]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.hspImage) === index)));
  }
  async function loadPreview() {
    const item = items.get(previewId), version = ++previewVersion;
    $('[data-hsp-preview-loading]').hidden = false;
    $('[data-hsp-preview-error]').hidden = true;
    $('[data-hsp-description]').replaceChildren();
    try {
      if (!previewCache.has(item.handle)) {
        const productRequest = fetch(cartRoot + 'products/' + encodeURIComponent(item.handle) + '.js', {credentials:'same-origin',headers:{Accept:'application/json'},signal:AbortSignal.timeout(12000)})
          .then(response => { if (!response.ok) throw new Error('Product unavailable'); return response.json(); })
          .catch(failure => { previewCache.delete(item.handle); throw failure; });
        previewCache.set(item.handle, productRequest);
      }
      const product = await previewCache.get(item.handle);
      if (version !== previewVersion || !dialog.open) return;
      $('[data-hsp-description]').replaceChildren(descriptionContent(product.description));
      const variant = product.variants?.find(value => String(value.id) === previewId);
      const images = [variant?.featured_image?.src || product.featured_image || item.image, ...(product.images || [])];
      const seen = new Set();
      previewImages = images.map(value => imageUrl(value)).filter(value => {
        if (!value) return false;
        const key = new URL(value).pathname;
        if (seen.has(key)) return false;
        seen.add(key); return true;
      });
      $('[data-hsp-thumbs]').innerHTML = previewImages.length > 1 ? previewImages.map((src, index) => `<button type="button" data-hsp-image="${index}" aria-pressed="${index === 0}" aria-label="${html(previewText('image',{name:item.name,index:index + 1,count:previewImages.length}))}"><img src="${html(imageUrl(src,120))}" alt="" width="60" height="60" loading="lazy"></button>`).join('') : '';
      selectPreviewImage(0);
    } catch {
      if (version === previewVersion && dialog.open) $('[data-hsp-preview-error]').hidden = false;
    } finally {
      if (version === previewVersion && dialog.open) $('[data-hsp-preview-loading]').hidden = true;
    }
  }
  function openPreview(id, opener) {
    const item = items.get(id);
    if (!item || busy || completed) return;
    previewId = id; previewOpener = opener;
    $('[data-hsp-preview-title]').textContent = item.name;
    $('[data-hsp-preview-variant]').textContent = item.variantTitle === 'Default Title' ? '' : item.variantTitle;
    $('[data-hsp-preview-price]').textContent = money(item.price);
    $('[data-hsp-thumbs]').replaceChildren();
    previewImages = item.image ? [item.image] : [];
    selectPreviewImage(0);
    if (!dialog.open) dialog.showModal();
    document.documentElement.classList.add('hsp-preview-open');
    $('[data-hsp-preview-scroll]').scrollTop = 0;
    renderPreviewControls();
    $('[data-hsp-close]').focus({preventScroll:true});
    loadPreview();
  }
  $$('[data-hsp-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('close', () => {
    previewVersion++;
    document.documentElement.classList.remove('hsp-preview-open');
    const opener = previewOpener?.isConnected ? previewOpener : $(`.hsp-details[data-hsp-preview="${previewId}"]`);
    previewId = ''; previewOpener = null;
    opener?.focus({preventScroll:true});
  });
  function outsidePreview(event) {
    const box = dialog.getBoundingClientRect();
    return event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom);
  }
  dialog.addEventListener('pointerdown', event => { backdropStart = outsidePreview(event); });
  dialog.addEventListener('click', event => { if (backdropStart && outsidePreview(event)) dialog.close(); backdropStart = false; });
  $('[data-hsp-preview-retry]').addEventListener('click', loadPreview);
  root.addEventListener('click', event => {
    const opener = event.target.closest('[data-hsp-preview]');
    if (opener) openPreview(opener.dataset.hspPreview, opener);
    const thumbnail = event.target.closest('[data-hsp-image]');
    if (thumbnail) selectPreviewImage(Number(thumbnail.dataset.hspImage));
  });
  function filterCatalog() {
    const query = $('[data-hsp-search]').value.toLocaleLowerCase().trim();
    let count = 0;
    $$('[data-card-id]').forEach(card => {
      const item = items.get(card.dataset.cardId);
      card.hidden = !`${item.name} ${item.variantTitle}`.toLocaleLowerCase().includes(query);
      if (!card.hidden) count++;
    });
    $('[data-hsp-no-results]').hidden = count > 0;
  }
  async function request(endpoint, data) {
    const response = await fetch(cartRoot + endpoint, {method:data === undefined ? 'GET' : 'POST', credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json',...(data === undefined ? {} : {'Content-Type':'application/json'})}, ...(data === undefined ? {} : {body:JSON.stringify(data)}), hebesoCartInternal:true});
    const result = await response.json();
    if (!response.ok || result.status >= 400) {
      const failure = new Error(result.description || result.message || words.load_error);
      failure.status = result.status || response.status; failure.endpoint = endpoint;
      throw failure;
    }
    return result;
  }
  async function readCart() { serverCart = await pricing.refresh(); return serverCart; }
  async function loadProduct(handle, variantId) {
    if (!/^[a-z0-9][a-z0-9-]*$/.test(handle || '') || (variantId && !/^\d+$/.test(String(variantId)))) throw new Error(words.seed_error);
    const existing = [...items.values()].find(item => item.handle === handle && (!variantId || String(item.variantId) === String(variantId)));
    if (existing) return existing;
    const product = await request('products/' + encodeURIComponent(handle) + '.js');
    const variant = variantId ? product.variants.find(item => String(item.id) === String(variantId)) : product.variants.find(item => item.available) || product.variants[0];
    if (!variant) throw new Error(words.seed_error);
    const item = {handle,variantId:variant.id,name:product.title,variantTitle:variant.title,price:variant.price,available:variant.available,image:variant.featured_image?.src || product.featured_image || product.images[0],source:cartRoot+'products/'+handle};
    items.set(String(item.variantId), item);
    return item;
  }
  async function showCart(message = '') {
    const cart = document.querySelector('hebeso-cart');
    if (cart?.open) { await cart.open(); if (message) cart.error(message); }
    else location.assign(cartRoot + 'cart');
  }
  function verify(state, key, selected, expected) {
    const lines = group(state,key);
    const actual = new Map();
    lines.forEach(line => actual.set(String(line.variant_id),(actual.get(String(line.variant_id)) || 0)+line.quantity));
    if (selected.some(item => actual.get(String(item.variantId)) !== item.quantity) || [...actual].some(([id]) => !selected.some(item => String(item.variantId) === id))) return words.cart_changed;
    if (lines.reduce((sum,line) => sum+line.final_line_price,0) > expected.total + 1) return words.price_changed;
    return '';
  }
  async function submit() {
    if (!canSubmit(pricing.quote(entries(),serverCart,edit?.key))) return;
    const selected = entries(), activeEdit = edit;
    const key = activeEdit?.key || 'h' + (crypto.randomUUID ? crypto.randomUUID().replaceAll('-','') : Date.now().toString(36)+Math.random().toString(36).slice(2));
    const properties = activeEdit?.properties || {_hebeso_set_id:key,_hebeso_set_mode:'bundle'};
    let changed = false, warning = '', cartBefore, expected;
    busy = true; error(''); render();
    document.querySelector('hebeso-cart')?.setBusy?.(true);
    try {
      cartBefore = await readCart();
      if (activeEdit && signature(group(cartBefore,key)) !== activeEdit.signature) throw new Error(words.edit_changed);
      expected = pricing.quote(selected,cartBefore,key);
      if (!activeEdit && expected.eligibleCount < 2) throw new Error(words.minimum);
      if (stock) await stock.assertAvailable(selected,cartBefore,activeEdit?.key);
      const additions = selected.flatMap(item => {
        const existing = activeEdit ? group(cartBefore,key).filter(line => String(line.variant_id) === String(item.variantId)).reduce((sum,line) => sum+line.quantity,0) : 0;
        return item.quantity > existing ? [{id:item.variantId,quantity:item.quantity-existing,properties}] : [];
      });
      if (additions.length) { await request('cart/add.js',{items:additions}); changed = true; }
      if (activeEdit) {
        const ids = [...new Set(group(cartBefore,key).map(line => String(line.variant_id)))];
        for (const id of ids) {
          await readCart();
          const lines = group(serverCart,key).filter(line => String(line.variant_id) === id);
          let remaining = selection.get(id) || 0;
          for (const line of lines) {
            const desired = Math.min(line.quantity,remaining);
            remaining -= desired;
            if (desired < line.quantity) { await request('cart/change.js',{id:line.key,quantity:desired}); changed = true; }
          }
        }
      }
      const finalCart = await readCart();
      warning = verify(finalCart,key,selected,expected);
      completed = true;
      completedKey = key;
      announce(activeEdit ? words.saved : words.added);
    } catch (failure) {
      if (failure.code !== 'HEBESO_STOCK') {
        try { const current = await readCart(); changed = changed || (activeEdit ? signature(group(current,key)) !== activeEdit.signature : group(current,key).length > 0); } catch {}
      }
      warning = stock ? await stock.describeFailure(failure,selected,cartBefore,activeEdit?.key) : failure.message;
      if (changed) { warning += '\n' + words.partial; completed = true; completedKey = key; }
      error(warning);
    } finally {
      busy = false;
      document.querySelector('hebeso-cart')?.setBusy?.(false);
      render();
      if (completed) {
        $('[data-hsp-finished]').hidden = false;
        await showCart(warning);
      }
    }
  }
  root.addEventListener('click', event => {
    const button = event.target.closest('[data-hsp-action]');
    if (!button || button.disabled || busy || !ready || completed) return;
    const id = button.dataset.id, item = items.get(id), current = selection.get(id) || 0;
    if (!item) return;
    const next = button.dataset.hspAction === 'remove' ? 0 : current + (button.dataset.hspAction === 'plus' ? 1 : -1);
    if (next < 0 || next > 99 || next > current && !item.available) return;
    selection.set(id,next); error(''); render();
    announce(text(next ? 'selection_updated' : 'selection_removed',{name:item.name,count:next}));
    if (!document.contains(button)) {
      const container = dialog.open ? $('[data-hsp-preview-controls]') : $(`[data-card-id="${id}"] [data-card-controls]`);
      container?.querySelector('button:not([disabled])')?.focus({preventScroll:true});
    }
  });
  $('[data-hsp-search]').addEventListener('input',filterCatalog);
  $$('[data-hsp-submit]').forEach(button => button.addEventListener('click',submit));
  $('[data-hsp-mobile-summary]').addEventListener('click',() => {
    $('[data-hsp-summary]').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
    $('[data-hsp-summary-title]').focus({preventScroll:true});
  });
  document.addEventListener('hebeso:pricing-updated',() => { if (!busy && ready) { serverCart = pricing.getCart(); render(); } });
  async function initialize() {
    if (!pricing) { error(words.load_error); return; }
    buildCatalog(); render();
    try {
      await readCart();
      const editKey = params.get('edit_set');
      if (editKey) {
        const lines = group(serverCart,editKey);
        if (!lines.length || lines.some(line => line.selling_plan_allocation)) throw new Error(words.edit_missing);
        for (const line of lines) {
          const handle = new URL(line.url,location.origin).pathname.split('/').filter(Boolean).pop();
          const item = await loadProduct(handle,line.variant_id);
          const id = String(item.variantId);
          selection.set(id,(selection.get(id) || 0)+line.quantity);
          if (!firstId) firstId = id;
        }
        edit = {key:editKey,signature:signature(lines),properties:{...lines[0].properties}};
      } else if (params.has('product')) {
        try {
          const item = await loadProduct(params.get('product'),params.get('variant'));
          firstId = String(item.variantId);
          if (item.available) {
            selection.set(firstId,1);
            $('[data-hsp-seed]').textContent = text('seeded',{name:item.name});
            $('[data-hsp-seed]').hidden = false;
          } else error(text('seed_unavailable',{name:item.name}));
        } catch { error(words.seed_error); }
      }
      ready = true;
      buildCatalog(); render();
      root.dataset.ready = 'true';
    } catch (failure) { error(failure.message || words.load_error); }
    finally { $('[data-hsp-loading]').hidden = true; }
  }
  initialize();
  }
  if (document.readyState === 'complete') initializePage();
  else document.addEventListener('DOMContentLoaded', initializePage, {once:true});
})();


  } catch(e) { console.error(e); }
})();
})();
